import React from 'react'
import { YOUR_PARTNER_ID, HASH_METHOD, EMAIL } from './config'
import useGetPrice from '../hooks/useGetPrice'

// https://help.criteo.com/kb/guide/en/all-criteo-onetag-events-and-parameters-vZbzbEeY86/Steps/775825,868658,868657,868659,2796770,868657,868656,2796773,868660,2796772,2796769
export default function CriteoProduct({ product }) {
    const { sku } = product
    const { price } = useGetPrice(product)
    return (
        <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
                __html: `
                    window.criteo_q = window.criteo_q || [];
                    var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                    window.criteo_q.push(
                        { event: "setAccount", account: ${YOUR_PARTNER_ID}},
                        { event: "setEmail", email: "${EMAIL}", hash_method: "${HASH_METHOD}" },
                        { event: "setSiteType", type: deviceType},
                        { event: "viewItem", item: "${sku}", price: "${price?.currency_symbol}${price?.promotion_price ?? price?.price}", availability: 1}
                    );
                `
            }}
        />
    )
}
